import Button from '../../../components/base/Button';

export default function HeroSection() {
  const handleCall = () => {
    window.location.href = 'tel:0491121950';
  };

  return (
    <section 
      id="home" 
      className="relative min-h-screen flex items-center justify-center"
    >
      {/* Background Image */}
      <div className="absolute inset-0">
        <img 
          src="https://static.readdy.ai/image/cd116a5342bbace3e474cedd10298d09/1adf9cf79317b954455bd95b81b8b41a.jpeg"
          alt="Luxury Car Detailing"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>
      
      <div className="relative z-10 w-full">
        <div className="max-w-7xl mx-auto px-4 py-16 sm:px-6">
          <div className="max-w-2xl text-center sm:text-left">
            <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4 sm:mb-6 leading-tight">
              <strong>Premium Ceramic Protection & Paint Correction – Mobile in Melbourne</strong>
            </h2>
            <p className="text-lg sm:text-xl md:text-2xl text-gray-300 mb-6 sm:mb-8 leading-relaxed">
              We come to you! Experience showroom shine wherever you are.
            </p>
            <div className="flex flex-col gap-3 sm:gap-4">
              <Button 
                size="lg" 
                onClick={handleCall}
                className="text-lg sm:text-xl px-8 py-4 sm:px-10 sm:py-5 w-full sm:w-auto"
              >
                Call Now
              </Button>
              <Button 
                variant="outline" 
                size="lg"
                onClick={() => {
                  const element = document.getElementById('services');
                  if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                  }
                }}
                className="text-lg sm:text-xl px-8 py-4 sm:px-10 sm:py-5 w-full sm:w-auto border-white text-white hover:bg-white hover:text-black"
              >
                View Services
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
